import { makeStyles } from '@mui/styles';

export const applicationStyles = makeStyles((theme) => ({
  labelText: {
    fontFamily: 'Open Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '700 !important',
    fontSize: '18px !important',
    lineHeight: '25px !important',
    color: '#14142B',
  },
  warningText : {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#d8b751 !important',
  },
  signUpBtn: {
    color: '#fff !important',
    background: 'rgba(57, 162, 219, 1) !important',
    borderRadius: '24px !important',
    padding: '9px 17px !important',
    height: '49px',
    '&.Mui-disabled': {
      background: 'rgba(211, 211, 211, 1) !important',
    },
  },
  signUpBtnText: {
    textTransform: 'capitalize',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    fontWeight: '700 !important',
    fontFamily: 'Work Sans !important',
  },
  wizardNextBtn: {
    border: '2px solid #39A2DB !important',
    borderRadius: '24px !important',
    padding: '9px 17px !important',
    height: '49px',
  },
  wizardAddNewBtn: {
    border: '1px solid #39A2DB !important',
    borderRadius: '24px !important',
    height: '39px',
  },
  wizardAddNewBtnText: {
    textTransform: 'capitalize',
    fontSize: '14px !important',
    fontWeight: '400 !important',
    fontFamily: 'Work Sans !important',
    color: '#39A2DB',
  },
  wizardNextBtnText: {
    textTransform: 'capitalize',
    fontSize: '18px !important',

    fontWeight: '700 !important',
    fontFamily: 'Work Sans !important',
    color: '#39A2DB',
  },
  wrapper: {
    margin: '1px',
    position: 'relative',
  },
  buttonProgress: {
    color: '#39A2DB',
    position: 'absolute',
    top: '12px',
    left: 'calc( 50% - 13px )',
  },
  optionalText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '15px !important',
    lineHeight: '18px !important',
    color: '#A8A8A8 !important',
  },
  bodyText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#000000 !important',
  },
  bodyTextBold: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#000000 !important',
  },
  bodyTextSmall: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '16px !important',
    lineHeight: '22px !important',
    color: '#000000 !important',
  },
  grayLabelText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '16px !important',
    lineHeight: '22px !important',
    color: '#A8A8A8 !important',
  },
  globalText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    fontSize: '16px !important',
    lineHeight: '22px !important',
    color: '#DB3939 !important',
    margin: '20px 20px 10px !important',
  },
  wizardText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    fontSize: '16px !important',
    lineHeight: '22px !important',
    color: '#A8A8A8 !important',
    margin: '0px 5px !important',
    maxWidth: '125px !important',
  },
  customInputStyle: {
    borderRadius: '24px !important',
    boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1) !important',
    outline: 'none !important',
    fontFamily: 'Work Sans !important',
    height: '45px  !important',
    marginBottom: '16px !important',
    '& legend span': {
      marginRight: '-6px',
    },
  },
  customInputPlaceholderStyle: {
    top: '-3px !important',
    '&.MuiInputLabel-shrink': {
      top: '0px !important',
    },
  },
  submitBtnText: {
    fontFamily: 'Work Sans !important',
    fontSize: '16px !important',
    lineHeight: '22px !important',
    color: '#39A2DB !important',
  },
  cardContainer: {
    width: '100%',
    height: 352,
    border: '3px solid #F1F0F5',
    borderRadius: '24px',
  },
  cardTopContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 74,
    borderBottom: '3px solid #F1F0F5',
  },
  statusText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    lineHeight: '24px !important',
  },
  cardLabelText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#000000 !important',
  },
  cardBodyText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '18px !important',
    lineHeight: '24px !important',
    color: '#000000 !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  entityHistoryItemSubtitle: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '12px !important',
    color: '#6B7280 !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  entityHistoryCompleteText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '14px !important',
    color: '#39DB8D !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  entityHistoryInCompleteText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '14px !important',
    color: '#FAAF00 !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  signNowText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '16px !important',
    lineHeight: '24px !important',
    color: '#000000 !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textDecoration: 'underline',
  },
  applicationNoteText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '14px !important',
    lineHeight: '22px !important',
    color: '#000000 !important',
  },
  incompleteLabelText: {
    fontFamily: 'Work Sans !important',
    fontSize: '12px !important',
    lineHeight: '22px !important',
    color: '#DB3939 !important',
    margin: '0 0 -8px 32px !important',
  },
  incompleteImage: {
    width: '12px',
    height: '20px',
    marginRight: '10px',
  },
  termsAndConditionLink: {
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#39A2DB !important",
    marginTop: "18px",
    cursor: "pointer",
  },
}));

export const applicantStyles = makeStyles((theme) => ({
  forgetText: {
    font: '14px Work Sans',
    lineHeight: '30px',
    color: '#39A2DB',
    textDecoration: 'none !important',
    maxHeight: '30px !important',
    margin: '10px !important',
    marginTop: '8px !important',
    marginBottom: '27px !important',
    paddingLeft: '5px !important',
    cursor: 'pointer',
  },
  signInBtn: {
    border: '2px solid #39A2DB !important',
    filter: 'drop-shadow(0px 0px 40px rgba(0, 0, 0, 0.1))',
    borderRadius: '50px !important',
    padding: '10px 12px !important',
  },
  signInText: {
    fontFamily: 'Open Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '700 !important',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#39A2DB',
    textTransform: 'capitalize',
  },
  largeText: {
    fontFamily: 'Open Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '700 !important',
    fontSize: '18px !important',
    lineHeight: '25px !important',
    color: '#14142B !important',
  },
  bodyText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#000000 !important',
  },
  errorText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#14142B !important',
  },
  formContainer: {
    borderRadius: '20px',
    border: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 340,
  },
  inputBox: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
    borderRadius: '24px',
    border: 'none',
    paddingLeft: '18px',
    width: '340px',
    height: '49px',
    fontFamily: 'Work Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '21px',
    color: '#14142B',
  },
  buttonContainer: {
    width: '340px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '20px',
  },
  wrapper: {
    margin: '1px',
    position: 'relative',
  },
  buttonProgress: {
    color: '#053742',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  pageError: {
    display: 'flex',
    flexDirection: 'row',
    borderTop: '2px  solid #DB3939',
    borderRadius: '24px',
    padding: '12px 20px',
    width: '340px',
    height: '49px',
    justifyContent: 'center',
  },
  checkboxError: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '24px',
    width: '340px',
    justifyContent: 'center',
    padding: '3px',
  },
  termsAndConditionLink: {
    fontFamily: 'Work Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    color: '#39A2DB',
    marginTop: '18px',
    cursor: 'pointer',
  },
  styleLink: {
    textDecoration: 'none',
  },
}));
